import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { I18nProvider } from './i18n';
import { AppStoreProvider } from './store';
import { AuthProvider } from './auth';
import './styles.css';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<BrowserRouter>
			<I18nProvider>
				<AuthProvider><AppStoreProvider><App /></AppStoreProvider></AuthProvider>
			</I18nProvider>
		</BrowserRouter>
	</StrictMode>,
);
